import { render, staticRenderFns } from "./AdAccount.vue?vue&type=template&id=65bccdc8&scoped=true&"
import script from "./AdAccount.vue?vue&type=script&lang=js&"
export * from "./AdAccount.vue?vue&type=script&lang=js&"
import style0 from "./AdAccount.vue?vue&type=style&index=0&id=65bccdc8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bccdc8",
  null
  
)

export default component.exports